import { isDev } from '@/utils/enviroment'

export let API: string | undefined
export let UploadAPI: string | undefined
export const tb: string | undefined = process.env.REACT_APP_TB
if (isDev()) {
    API = process.env.REACT_APP_DEVLOPMENT_API_URL
    UploadAPI = 'http://10.217.2.232:31051'
} else if (process.env.NODE_ENV === 'production') {
    API = process.env.REACT_APP_PRODUCTION_API_URL
    UploadAPI = 'http://10.133.34.120:31251'
}
